var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"fieldset"},[_c('legend',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('span',{staticClass:"field-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }